import {Box, HStack, Text} from '@tempo/core';
import Thumbnail from '@components/Thumbnail';
import {ContentType} from '@deezer/next/services/types/contentType';
import HighlightedText from '@components/Navigation/SearchBar/HighlightedText';
import {NavLink} from '@tempo/nextjs';
import React from 'react';
import type {
	TrackSearchResult,
	ArtistSearchResult,
} from '@deezer/next/services/api/Starmania/requests/search/types';

type TrackSearchResultItemProps = {
	query: string;
	track: TrackSearchResult;
};

export const TrackSearchResultItem = ({
	query,
	track,
}: TrackSearchResultItemProps) => {
	const redirectUrl = track.redirectUrl + `?deezerId=${track.id}`;

	return (
		<NavLink href={redirectUrl}>
			<HStack spacing={3}>
				<Thumbnail
					id={String(track.id)}
					picture={track.picture}
					type={ContentType.Track}
					width={'62px'}
					height={'62px'}
					coverLink={false}
				/>
				<Box>
					<Text
						as="h4"
						variant="body.default.regular"
						data-testid="search-item-title"
						noOfLines={1}
					>
						<HighlightedText query={query}>{track.title}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						noOfLines={1}
						color="text.neutral.secondary.default"
					>
						by{' '}
						<HighlightedText query={query}>
							{track.artists
								.map((artist: ArtistSearchResult) => artist.name)
								.join(', ')}
						</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						color="text.neutral.secondary.default"
					>
						Deezer ID:{' '}
						<HighlightedText query={query}>{String(track.id)}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						color="text.neutral.secondary.default"
					>
						ISRC: <HighlightedText query={query}>{track.isrc}</HighlightedText>
					</Text>
				</Box>
			</HStack>
		</NavLink>
	);
};

export default TrackSearchResultItem;
